<div v-if="$route.name === 'view_topic'">
  <button class="btn btn-primary btn-sm text-xxs shadow mb-3" data-bs-toggle="modal" data-bs-target="#feed_modal">+
    Create Feed</button>
</div>

<!-- Otherwise, show full feed card (hide on the 'view_report_topic' route) -->

  <div class="card border-1 rounded-5 mb-2"  v-else-if="(((soulcity_domain && user_details.user_role === 'admin') || !soulcity_domain) && ($route.name !== 'view_report_topic' && $route.name !== 'view_report_tag'))"
  data-bs-toggle="modal" data-bs-target="#feed_modal"
  @click="fetch_portal_members">
      <div class="feed-composer-row d-flex align-items-center gap-3">
        <div class="feed-composer-avatar">
          <img :src="profileImage || require('@/assets/images/user.png')" alt="Profile">
        </div>
        <button type="button" class="feed-composer-prompt flex-grow-1 text-xxs" aria-label="Create a post"
          data-bs-toggle="modal" data-bs-target="#feed_modal">
          <span>What's on your mind, {{ composer_display_name }}?</span>
        </button>
        <div class="feed-composer-actions d-none d-sm-flex">
          <button type="button" class="feed-composer-action feed-composer-action-recording"
            data-bs-toggle="modal" data-bs-target="#feed_modal" title="Recording">
            <i class="bi bi-mic-fill action-icon"></i>
          </button>
          <button type="button" class="feed-composer-action feed-composer-action-media"
            data-bs-toggle="modal" data-bs-target="#feed_modal" title="Images">
            <i class="bi bi-image-fill action-icon"></i>
          </button>
          <button type="button" class="feed-composer-action feed-composer-action-video"
            data-bs-toggle="modal" data-bs-target="#feed_modal" title="Video">
            <i class="bi bi-play-btn-fill action-icon"></i>
          </button>
        </div>
      </div>
    </div>



<!-- Feed Modal -->

<teleport to="body">
  <div class="modal fade" id="feed_modal" tabindex="-1" aria-labelledby="createPostModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content rounded shadow create-feed-modal-content">
        <div class="modal-header bg-primary position-relative">
          <h5 class="modal-title text-white" id="createPostModalLabel">Create feed</h5>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal" aria-label="Close">
          </button>
        </div>
        <form @submit.prevent="submit_form" class="p-2">
          <div class="post-content">
            <div v-if= "!dwypd_domain && !soulcity_domain" class="user-info">

              <div class="user-avatar">
                <img :src="profileImage || require('@/assets/images/user.png')" alt="User Avatar">
              </div>
              <div>
                <div v-if="$route.path.includes('profile')" class="user-name mb-0"> {{companyName || profileName}}</div>
                <div v-else-if="!activeProfile?.company?.company_name" class="user-name mb-0">
                  {{activeProfile?.user?.first_name}} {{activeProfile?.user?.last_name}}</div>
                <div v-else class="user-name mb-0">{{activeProfile?.company?.company_name}}</div>
              </div>
            </div>
            <div>
              <div class="d-flex flex-wrap align-items-center mt-2 mb-3 gap-2">



                <!-- Author Selection -->
                <div v-if="(dwypd_domain || visible_domain) && $route.name !== 'view_portal'"
                  class="d-flex align-items-center flex-wrap gap-2">
                  <!-- Add Author button -->

                  <button type="button" class="btn btn-sm btn-outline-secondary text-xxs px-3 py-1"
                    @click="openAuthorModal">
                    Add Author
                  </button>

                  <!-- Selected cAuthor display (rectangular box) -->
                  <!-- Display all authors as badges -->
                  <div v-if="authors.length" class="d-flex flex-wrap gap-2">
                    <span v-for="(author, index) in authors" :key="index"
                      class="btn-sm d-flex align-items-center bg-light border fw-bold">
                      {{ author.author_name }}
                      <a v-if="author.link" :href="author.link" target="_blank"
                        class="text-white ms-1 text-decoration-underline" @click.stop>
                        🔗
                      </a>
                      <button type="button" class="btn-close btn-close-dark btn-sm ms-1" aria-label="Remove"
                        @click="removeAuthor(index)"></button>
                    </span>
                  </div>

                </div>

                <!-- Portal Dropdown -->
                <div v-if="$route.name !== 'view_portal' && $route.name !== 'publish_portal'"
                  class="d-flex flex-column">
                  <select class="btn btn-sm btn-outline-secondary text-xxs px-4 py-1 mb-1" v-model="selectedPortalId"
                    @change="onPortalChange">
                    <option value="" selected hidden>Tag a portal</option>
                    <option v-for="portal in portals" :value="portal.id" :key="portal.id">
                      {{ portal.name }}
                    </option>
                  </select>
                  <p v-if="errors.portal" class="text-danger text-xs mt-1 mb-0">{{ errors.portal }}</p>
                </div>

                <!-- Segment / Topic Dropdown -->
                <div v-if="topics.length > 0 && $route.name !== 'publish_portal'">
                  <select class="btn btn-sm btn-outline-secondary text-xxs px-3 py-1 mb-1" v-model="selectedTopicId">
                    <option value="" selected hidden>Tag a segment</option>
                    <option v-for="topic in topics" :value="topic.id" :key="topic.id">
                      {{ topic.name }}
                    </option>
                  </select>
                </div>

                <!-- Tag Category -->
                <div v-if="(dwypd_domain ||visible_domain ) && ($route.name === 'publish_portal' ||
                ($route.name !== 'view_portal' && selectedPortal?.portal_type?.name === 'publishing')
    )" class="d-flex align-items-center flex-wrap gap-2">
                  <button type="button" class="btn btn-sm btn-outline-secondary text-xxs px-3 py-1"
                    @click="openCategoryModal">
                    Tag a Category
                  </button>
                  <div v-for="cat in selected_categories" :key="cat.id"
                    class="btn-sm d-flex align-items-center bg-light border px-3 py-1">
                    <span class="fw-bold text-xxs me-2">{{ cat.name }}</span>
                  </div>
                </div>

              </div>
              <div class="d-flex align-items-center mb-3">
                <label for="toggle-comments" class="form-label mb-0 text-xs fw-500">Allow comments:</label>
                <div class="form-check form-switch comment-switch">
                  <input class="form-check-input" type="checkbox" id="toggle-comments" v-model="comments_off">
                </div>
                <label class="form-check-label text-xxs" for="toggle-comments">{{ comments_off ? 'Yes' : 'No' }}</label>
              </div>


            </div>

            <div class="textarea-container">
              <div id="quillEditor" class="quill-editor" ref="quillReportEditorRef">

              </div>
              <div v-if="showSuggestions && filteredUsers.length > 0" class="suggestions-dropdown modal-body-scroll">
                <div v-for="user in filteredUsers" :key="user.id" class="suggestion-item" @mousedown="selectUser(user)">
                  {{ user.full_name }}
                </div>
              </div>
              <div v-if="linkPreview" class="link-preview rounded mt-2 p-2 position-relative">
                <button v-if="linkPreview" type="button" class="close-button" @click="linkPreview = null">
                  <i class="bi bi-x fw-bold"></i>
                </button>

                <img v-if="linkPreview.image" :src="linkPreview.image" class="img-fluid rounded" />
                <div class="fw-bold mt-2">{{ linkPreview.title }}</div>
                <div class="text-muted small">{{ linkPreview.description ||'' }}</div>
              </div>

              <div v-if="fileError" class="text-xs text-danger fst-italic mt-1">{{ fileError }}</div>

              <div v-if="audio_attachments.length" class="audio-attachment-list mt-2">
                <div v-for="(audio, index) in audio_attachments" :key="`${audio.name}-${index}`" class="audio-attachment-card">
                  <div class="audio-attachment-icon">
                    <i class="bi bi-mic-fill"></i>
                  </div>
                  <div class="audio-attachment-body">
                    <div class="audio-attachment-label">Recording {{ index + 1 }}</div>
                    <div class="audio-attachment-name">{{ audio.name }}</div>
                  </div>
                  <button type="button" class="audio-attachment-remove" @click="removeAudioAttachment(index)">
                    <i class="bi bi-x"></i>
                  </button>
                </div>
              </div>
              <div v-if="audioError" class="text-xs text-danger fst-italic mt-1">
                {{ audioError }}
              </div>


              <div v-if="previews.length" class="d-flex flex-wrap gap-3 mt-3 px-1">
                <div v-for="(preview, index) in previews" :key="index" class="preview-item position-relative mb-2">

                  <img v-if="preview.type === 'image'" :src="preview.src" class="preview-image rounded-3 border" />

                  <div v-else-if="preview.type === 'video'" class="position-relative w-100 h-100">
                    <video class="preview-video rounded border">
                      <source :src="preview.src" />
                    </video>
                    <i
                      class="bi bi-play-circle-fill position-absolute top-50 start-50 translate-middle text-white fs-3 opacity-75"></i>
                  </div>

                  <div v-else
                    class="preview-item rounded-3 border bg-light d-flex flex-column align-items-center justify-content-center text-center p-1">
                    <i v-if="preview.name.endsWith('.pdf')" class="bi bi-file-earmark-pdf-fill text-danger fs-2"></i>
                    <i v-else-if="preview.name.endsWith('.doc') || preview.name.endsWith('.docx')"
                      class="bi bi-file-earmark-word-fill text-primary fs-2"></i>
                    <i v-else-if="preview.name.endsWith('.xls') || preview.name.endsWith('.xlsx')"
                      class="bi bi-file-earmark-excel-fill text-success fs-2"></i>
                    <i v-else class="bi bi-file-earmark-text-fill text-secondary fs-2"></i>

                    <span class="text-xxs text-truncate w-100 px-1">{{ preview.name }}</span>
                  </div>

                  <button type="button"
                    class="btn btn-sm btn-danger fw-bold position-absolute top-0 end-0  fs-6 px-2 py-0"
                    @click="removeFile(index)">
                    &times;
                  </button>
                </div>
              </div>

            </div>
            <div v-if="errors.report_description" class="error-message">
              {{ errors.report_description }}
            </div>
          </div>
          <!-- Add to post -->
          <div class="p-3">
            <label
              for="feedFileInput"
              class="drop-zone-stable d-flex align-items-center justify-content-center pointer border-2 rounded p-3 mb-3 text-center transition-all position-relative"
              :class="isDragging ? 'border-primary bg-primary-subtle' : 'border-dashed'"
              @dragover.prevent="isDragging = true" @dragenter.prevent="isDragging = true"
              @dragleave.prevent="isDragging = false" @drop.prevent="handle_drop">
              <div class="d-flex align-items-center justify-content-center gap-2 h-100">
                <i class="bi bi-cloud-plus-fill text-primary fs-4"></i>
                <span class="fw-bold text-black text-sm">Drag & Drop media here or click</span>
              </div>

              <input
                id="feedFileInput"
                :key="`feed-file-${file_input_key}`"
                type="file"
                ref="fileInput"
                class="webview-file-input"
                multiple
                accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                @change="handleFileUpload">
            </label>
            <div
              class="add-to-post d-flex align-items-center justify-content-between border rounded bg-white shadow-sm">
              <div class="add-to-post-text fw-bold mb-1">Add to your feed</div>

              <div class="d-flex flex-row align-items-center pe-1">
                <label for="feedFileInputRef" class="post-option-btn d-flex align-items-center justify-content-center border-0" title="Images & Docs">
                  <i class="bi bi-images text-success"></i>
                  <input
                    id="feedFileInputRef"
                    :key="`feed-file-ref-${file_input_key}`"
                    type="file"
                    ref="fileInputRef"
                    class="webview-file-input"
                    multiple
                    accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                    @change="handleFileUpload" />
                </label>

                <label for="feedAudioInput" class="post-option-btn d-flex align-items-center justify-content-center mb-0">
                  <i class="bi bi-music-note-beamed text-primary"></i>
                  <input
                    id="feedAudioInput"
                    :key="`feed-audio-${audio_input_key}`"
                    type="file"
                    accept="audio/*"
                    class="webview-file-input"
                    multiple
                    @change="handleAudioUpload" />
                </label>

                <div class="d-flex align-items-center border-start ms-2 ps-2">
                  <button type="button" class="post-option-btn d-flex align-items-center justify-content-center border-0"
                    @click="startRecording" v-if="!isRecording">
                    <i class="bi bi-mic-fill text-danger"></i>
                  </button>

                  <button type="button" class="post-option-btn d-flex align-items-center justify-content-center border-0 pulse-red"
                    @click="stopRecording" v-if="isRecording">
                    <i class="bi bi-stop-circle-fill text-danger"></i>
                  </button>

                  <span v-if="isRecording" class="text-danger fw-bold text-xs ms-1">{{ formattedTime }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Post button separated with margin -->
          <div class="post-button-container mt-3 d-flex justify-content-end">
            <p v-if="errors.report_details" class="text-danger text-xs">{{ errors.report_details }}</p>
            <button class="btn btn-primary rounded-3 shadow-sm" type="submit" :disabled="is_post_empty">Post</button>
          </div>

        </form>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="edit_report_modal" tabindex="-1" aria-labelledby="editReportModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <h5 class="modal-title text-white" id="editReportModalLabel">Edit your Feed</h5>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form @submit.prevent="edit_report_data" class="p-2">
          <div class="modal-body">
            <div v-if= "!dwypd_domain && !soulcity_domain" class="user-info ">

            <div class="user-avatar">
              <img :src="profileImage || require('@/assets/images/user.png')" alt="User Avatar">
            </div>
            <div>
              <div v-if="$route.path.includes('profile')" class="user-name mb-0"> {{companyName || profileName}}</div>
                <div v-else-if="!activeProfile?.company?.company_name" class="user-name mb-0">
                  {{activeProfile?.user?.first_name}} {{activeProfile?.user?.last_name}}</div>
                <div v-else class="user-name mb-0">{{activeProfile?.company?.company_name}}</div>
              </div>
            </div>
            <div v-if="(dwypd_domain || visible_domain) && $route.name !== 'view_portal'" class="mt-2 m-2 d-flex align-items-center flex-wrap gap-2">
              <span class="btn btn-sm btn-outline-secondary text-xxs px-3 py-1" @click="openEditCategoryModal">Tag a category</span>
              <div class="d-flex flex-wrap gap-1">
                <span v-for="tag in Edit_selected_tags" :key="tag.id" class="btn-sm d-flex align-items-center bg-light border px-3 py-1">
                  {{ tag.name }}
                </span>
              </div>

              <span v-if="dwypd_domain || soulcity_domain || visible_domain" class="btn btn-sm btn-outline-secondary text-xxs px-3 py-1" @click="openEditAuthorModal">Edit Author</span>
              <div v-if="(dwypd_domain || soulcity_domain || visible_domain) && report_edit && report_edit.authors && report_edit.authors.length" class="d-flex flex-wrap gap-2 align-items-center">
                <span v-for="(author, index) in report_edit.authors" :key="index" class="btn-sm d-flex align-items-center bg-light border">
                  {{ author.author_name }}
                  <a v-if="author.link || author.author_link" :href="author.link || author.author_link" target="_blank" class="ms-1 text-decoration-underline" @click.stop>Link</a>
                  <button type="button" class="btn-close btn-close-dark btn-sm ms-1" aria-label="Remove" @click="removeEditAuthor(index)"></button>
                </span>
              </div>
            </div>

            <div v-if="topics.length > 0" class="m-2 d-flex align-items-center flex-wrap gap-2">
              <label class="form-label text-xxs fw-500">Segment (Topic)</label>
              <select class="btn btn-sm btn-outline-secondary text-xxs px-3 py-1" v-model="edit_selected_topic" id="edit_topic">
                <option value="" selected hidden>Tag a segment</option>
                <option v-for="topic in topics" :value="topic.id" :key="topic.id">
                  {{ topic.name }}
                </option>
              </select>
            </div>
            <div class="d-flex align-items-center mb-3">
              <label for="edit-toggle-comments" class="form-label mb-0 text-xs fw-500">Allow comments:</label>
              <div class="form-check form-switch comment-switch">
                <input class="form-check-input" type="checkbox" id="edit-toggle-comments" v-model="edit_comments_off">
              </div>
              <label class="form-check-label text-xxs" for="edit-toggle-comments">{{ edit_comments_off ? 'Yes' : 'No' }}</label>
            </div>

            <QuillEditor theme="snow" v-model="edit_report_description" ref="quillEditReportRef" class="quill-editor" toolbar="full" />

            <div v-if="report_edit.linkPreview" class="link-preview rounded mt-2 p-2 position-relative border">
              <a :href="report_edit.report_link" target="_blank" class="stretched-link text-decoration-none">
                <img v-if="report_edit.linkPreview.image" :src="report_edit.linkPreview.image" class="img-fluid rounded" />
                <div class="fw-bold mt-2">{{ report_edit.linkPreview.title }}</div>
                <div v-if="!report_edit.linkPreview.image" class="text-muted small">{{ report_edit.linkPreview.description }}</div>
              </a>
            </div>

            <div class="mt-4">
              <label for="editFileInput" class="drop-zone-stable d-flex align-items-center justify-content-center pointer border-2 rounded p-3 mb-3 text-center transition-all position-relative"
                :class="edit_isDragging ? 'border-primary bg-primary-subtle' : 'border-dashed'"
                @dragover.prevent="edit_isDragging = true" @dragenter.prevent="edit_isDragging = true"
                @dragleave.prevent="edit_isDragging = false" @drop.prevent="handle_edit_drop">
                <div class="d-flex align-items-center justify-content-center gap-2 h-100">
                  <i class="bi bi-cloud-plus-fill text-primary fs-4"></i>
                  <span class="fw-bold text-black text-sm">Drag & Drop media here or click</span>
                </div>
                <input
                  id="editFileInput"
                  :key="`edit-file-${edit_file_input_key}`"
                  type="file"
                  ref="editFileInput"
                  class="webview-file-input"
                  multiple
                  accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                  @change="handleEditFileUpload">
              </label>

              <div class="add-to-post d-flex align-items-center justify-content-between border rounded bg-white shadow-sm mb-2">
                <div class="add-to-post-text fw-bold mb-1">Add to your feed</div>
                <div class="d-flex flex-row align-items-center pe-1">
                  <label for="editFileInputRef" class="post-option-btn d-flex align-items-center justify-content-center border-0" title="Images & Docs">
                    <i class="bi bi-images text-success"></i>
                    <input
                      id="editFileInputRef"
                      :key="`edit-file-ref-${edit_file_input_key}`"
                      type="file"
                      class="webview-file-input"
                      multiple
                      accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                      @change="handleEditFileUpload" />
                  </label>
                  <label for="editAudioInput" class="post-option-btn d-flex align-items-center justify-content-center mb-0">
                    <i class="bi bi-music-note-beamed text-primary"></i>
                    <input
                      id="editAudioInput"
                      :key="`edit-audio-${audio_input_key}`"
                      type="file"
                      accept="audio/*"
                      class="webview-file-input"
                      multiple
                      @change="handleAudioUpload" />
                  </label>
                  <div class="d-flex align-items-center border-start ms-2 ps-2">
                    <button type="button" class="post-option-btn d-flex align-items-center justify-content-center border-0" @click="startRecording" v-if="!isRecording">
                      <i class="bi bi-mic-fill text-danger"></i>
                    </button>
                    <button type="button" class="post-option-btn d-flex align-items-center justify-content-center border-0 pulse-red" @click="stopRecording" v-if="isRecording">
                      <i class="bi bi-stop-circle-fill text-danger"></i>
                    </button>
                    <span v-if="isRecording" class="text-danger fw-bold text-xs ms-1">{{ formattedTime }}</span>
                  </div>
                </div>
              </div>

              <div v-if="audio_attachments.length" class="audio-attachment-list mt-3">
                <div class="audio-attachment-summary">
                  <span>New audio attachments</span>
                  <span>{{ audio_attachments.length }}/10</span>
                </div>
                <div v-for="(audio, index) in audio_attachments" :key="`edit-${audio.name}-${index}`" class="audio-attachment-card">
                  <div class="audio-attachment-icon">
                    <i class="bi bi-mic-fill"></i>
                  </div>
                  <div class="audio-attachment-body">
                    <div class="audio-attachment-label">Recording {{ index + 1 }}</div>
                    <div class="audio-attachment-name">{{ audio.name }}</div>
                  </div>
                  <button type="button" class="audio-attachment-remove" @click="removeAudioAttachment(index)">
                    <i class="bi bi-x"></i>
                  </button>
                </div>
              </div>

              <div v-if="edit_previews.length" class="d-flex flex-wrap gap-3 mt-3 px-1">
                <div v-for="(preview, index) in edit_previews" :key="index" class="preview-item position-relative mb-2">
                  <img v-if="preview.type === 'image'" :src="preview.src" class="preview-image rounded-3 border" />
                  <div v-else-if="preview.type === 'video'" class="position-relative w-100 h-100">
                    <video class="preview-video rounded border">
                      <source :src="preview.src" />
                    </video>
                    <i class="bi bi-play-circle-fill position-absolute top-50 start-50 translate-middle text-white fs-3 opacity-75"></i>
                  </div>
                  <div v-else class="preview-item rounded-3 border bg-light d-flex flex-column align-items-center justify-content-center text-center p-1">
                    <i v-if="preview.name.endsWith('.pdf')" class="bi bi-file-earmark-pdf-fill text-danger fs-2"></i>
                    <i v-else-if="preview.name.endsWith('.doc') || preview.name.endsWith('.docx')" class="bi bi-file-earmark-word-fill text-primary fs-2"></i>
                    <i v-else-if="preview.name.endsWith('.xls') || preview.name.endsWith('.xlsx')" class="bi bi-file-earmark-excel-fill text-success fs-2"></i>
                    <i v-else class="bi bi-file-earmark-text-fill text-secondary fs-2"></i>
                    <span class="text-xxs text-truncate w-100 px-1">{{ preview.name }}</span>
                  </div>
                  <button type="button" class="btn btn-sm btn-danger fw-bold position-absolute top-0 end-0 fs-6 px-2 py-0" @click="remove_edit_preview(index)">
                    &times;
                  </button>
                </div>
              </div>
            </div>

            <div class="d-flex flex-column" v-if="edit_documents.report_files && edit_documents.report_files.length">
              <div class="row g-3 gap-2">
                <div v-for="(fileObj, index) in edit_documents.report_files" :key="index" class="preview-item position-relative mb-2">
                  <button type="button" class="btn btn-sm btn-danger fw-bold position-absolute top-0 end-0 fs-6 px-2 py-0" aria-label="Remove" @click="markEditFileForRemoval(fileObj.id, index)">
                    &times;
                  </button>
                  <img v-if="get_edit_report_file_url(fileObj).includes('.jpg') || get_edit_report_file_url(fileObj).includes('.png') || get_edit_report_file_url(fileObj).includes('.jpeg')"
                    :src="get_edit_report_file_url(fileObj)" alt="Feed Image" class="preview-image rounded-3 border" />
                  <div v-else-if="get_edit_report_file_url(fileObj).includes('.mp3') || get_edit_report_file_url(fileObj).includes('.wav')" class="edit-audio-card">
                    <div class="audio-post-header justify-content-between d-flex align-items-center g-1">
                      <div class="audio-post-icon">
                        <i class="bi bi-mic-fill"></i>
                      </div>
                        <div class="audio-post-name">{{ fileObj.file?.name || get_edit_file_name(get_edit_report_file_url(fileObj)) }}</div>
                    </div>
                    <audio controls class="audio-post-player">
                      <source :src="get_edit_report_file_url(fileObj)" type="audio/mp3" />
                      Your browser does not support the audio element.
                    </audio>
                  </div>
                  <video v-else-if="/\.(mp4|webm|ogg|ogv|mov|m4v|avi|mkv|wmv|flv|3gp|3g2)(?:$|[?#])/i.test(get_edit_report_file_url(fileObj))" controls class="img-fluid rounded-5 w-100">
                    <source :src="get_edit_report_file_url(fileObj)" />
                    Your browser does not support the video tag.
                  </video>
                  <div v-else class="preview-item rounded-3 border bg-light d-flex flex-column align-items-center justify-content-center text-center p-1">
                    <i v-if="get_edit_report_file_url(fileObj).includes('.pdf')" class="bi bi-file-earmark-pdf-fill text-danger fs-2"></i>
                    <i v-else-if="get_edit_report_file_url(fileObj).includes('.doc') || get_edit_report_file_url(fileObj).includes('.docx')" class="bi bi-file-earmark-word-fill text-primary fs-2"></i>
                    <i v-else-if="get_edit_report_file_url(fileObj).includes('.xls') || get_edit_report_file_url(fileObj).includes('.xlsx')" class="bi bi-file-earmark-excel-fill text-success fs-2"></i>
                    <i v-else class="bi bi-file-earmark-text-fill text-secondary fs-2"></i>
                    <span class="text-xxs text-truncate w-100 px-1">{{ fileObj.file?.name || get_edit_file_name(get_edit_report_file_url(fileObj)) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xxs rounded">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="category_modal_edit" tabindex="-1" aria-labelledby="category_modal_edit_label" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content border-0 rounded-5 shadow scrollable-container">
        <div class="modal-header bg-primary position-relative">
          <h6 class="modal-title text-white text-xs" id="category_modal_edit_label">Select Tags for Category</h6>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-4">
            <label class="form-label fw-bold mb-1">Primary Tag</label>
            <div v-for="(category, index) in grouped_tags" :key="'edit-primary-'+category.id" v-show="index < 2 || showAllPrimary" class="col-md-12">
              <label class="form-label fw-bold mb-1 text-xxs">{{ category.name }}</label>
              <multiselect :model-value="edit_primary_tags.get(category.id)" @update:modelValue="tag => selectEditPrimaryTag(category.id, tag)" :options="category.tags" :multiple="false" placeholder="Select primary tag" track-by="id" label="name" class="text-xs fw-500 mb-3" />
            </div>
          </div>
          <div class="mb-4">
            <label class="form-label fw-bold mb-1">Secondary Tags</label>
            <div v-for="(category, index) in grouped_tags" :key="'edit-secondary-'+category.id" v-show="index < 2 || showAllSecondary" class="col-md-12">
              <label class="form-label fw-bold mb-1 text-xxs">{{ category.name }}</label>
              <multiselect :model-value="edit_selected_tags.get(category.id)" @update:modelValue="updateEditTagSelection(category.id, $event)" :options="category.tags" :multiple="true" :preserve-search="true" :close-on-select="false" :clear-on-select="false" placeholder="Select tags" class="text-xs fw-500 mb-3" track-by="id" label="name" />
            </div>
          </div>
        </div>
        <div class="text-end">
          <button type="button" class="btn btn-primary btn-sm text-xxs rounded-3 shadow-sm m-3" @click="submit_edit_tags" data-bs-toggle="modal" data-bs-target="#edit_report_modal" data-bs-dismiss="modal">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="author_modal_edit" tabindex="-1" aria-labelledby="author_modal_edit_label" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content border-0 rounded-5 shadow scrollable-container">
        <div class="modal-header bg-primary position-relative">
          <h6 class="modal-title text-white text-xs" id="author_modal_edit_label">Edit Authors</h6>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <input type="text" class="form-control form-control-sm mb-2 rounded" v-model="edit_author_input" placeholder="Enter author name" />
          <input type="url" class="form-control form-control-sm mb-2 rounded" v-model="edit_author_link" placeholder="Enter author link (optional)" />
          <button type="button" class="btn btn-primary btn-sm mb-2 rounded" @click="addEditAuthor">
            Add Author
          </button>
          <div v-if="edit_authors.length" class="mt-2">
            <div class="d-flex flex-wrap justify-content-start">
              <div v-for="(author, index) in edit_authors" :key="index" class="d-flex align-items-start mb-1">
                <span class="btn-sm d-flex align-items-center bg-light border px-3 py-1">
                  {{ author.author_name }}
                  <button type="button" class="btn-close btn-close-dark btn-sm ms-1" aria-label="Remove" @click="removeEditAuthor(index)"></button>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary btn-sm rounded" @click="saveEditAuthors">Save</button>
        </div>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="category_modal" tabindex="-1" aria-labelledby="category_modal_label" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content border-0 rounded-5 shadow scrollable-container">
        <div class="modal-header bg-primary position-relative">
          <h6 class="modal-title text-white text-xs" id="category_modal_label">Select Tags for Category</h6>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">

          <!-- PRIMARY TAG -->
          <div class="mb-4">
            <label class="form-label fw-bold mb-1">Primary Tag</label>

            <div v-for="(category, index) in grouped_tags" :key="'primary-'+category.id"
              v-show="index < 2 || showAllPrimary" class="col-md-12">
              <label class="form-label fw-bold mb-1 text-xxs">{{ category.name }}</label>
              <multiselect :model-value="primary_tags.get(category.id)"
                @update:modelValue="tag => selectPrimaryTag(category.id, tag)" :options="category.tags"
                :multiple="false" placeholder="Select primary tag" track-by="id" label="name"
                class="text-xs fw-500 mb-3">
                <template #option="{ option }">
                  <span class="fw-500 text-xxs">{{ option.name }}</span>
                </template>
                <template #selection="{ values }">
                  <span v-if="values" class="badge bg-success">{{ values.name }}</span>
                </template>
              </multiselect>



            </div>

            <div v-if="grouped_tags.length > 2" class="mt-2">
              <button type="button" class="btn btn-link btn-sm text-decoration-none"
                @click="showAllPrimary = !showAllPrimary">
                {{ showAllPrimary ? 'Show Less' : 'Show More' }}
              </button>
            </div>
          </div>


          <!-- SECONDARY TAGS -->
          <div class="mb-4">
            <label class="form-label fw-bold mb-1">Secondary Tags</label>

            <div v-for="(category, index) in grouped_tags" :key="'secondary-'+category.id"
              v-show="index < 2 || showAllSecondary" class="col-md-12">
              <label class="form-label fw-bold mb-1 text-xxs">{{ category.name }}</label>

              <multiselect :model-value="selected_tags.get(category.id)"
                @update:modelValue="updateTagSelection(category.id, $event)" :options="category.tags" :multiple="true"
                :preserve-search="true" :close-on-select="false" :clear-on-select="false" placeholder="Select tags"
                class="text-xs fw-500 mb-3" track-by="id" label="name">
                <template #option="{ option }">
                  <span class="fw-500 text-xxs">{{ option.name }}</span>
                </template>
                <template #selection="{ values }">
                  <span v-for="(tag, index) in values" :key="index" class="badge bg-primary me-1">
                    {{ tag.name }}
                  </span>
                </template>
              </multiselect>
            </div>

            <div v-if="grouped_tags.length > 2" class="mt-2">
              <button type="button" class="btn btn-link btn-sm text-decoration-none"
                @click="showAllSecondary = !showAllSecondary">
                {{ showAllSecondary ? 'Show Less' : 'Show More' }}
              </button>
            </div>
          </div>

        </div>

        <div class="text-end">
          <button type="button" class="btn btn-primary btn-sm text-xxs rounded-3 shadow-sm m-3" @click="submit_tags"
            data-bs-toggle="modal" data-bs-target="#feed_modal" data-bs-dismiss="modal">
            Save
          </button>
        </div>

      </div>
    </div>
  </div>
</teleport>




<teleport to="body">
  <div class="modal fade" id="author_modal" tabindex="-1" aria-labelledby="author_modal_label" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content border-0 rounded-5 shadow scrollable-container">
        <div class="modal-header bg-primary position-relative">
          <h6 class="modal-title text-white text-xs" id="author_modal_label">Add Authors</h6>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <!-- Inputs for new author -->
          <input type="text" class="form-control form-control-sm mb-2 rounded" v-model="authorName"
            placeholder="Enter author name" />

          <input type="url" class="form-control form-control-sm mb-2 rounded" v-model="authorLink"
            placeholder="Enter author link (optional)" />

          <button type="button" class="btn btn-primary btn-sm mb-2 rounded" @click="addAuthor">
            Add Author
          </button>

          <!-- List of added authors (aligned right) -->
          <div v-if="authors.length" class="mt-2">
            <div class="d-flex flex-wrap justify-content-start ">
              <div v-for="(author, index) in authors" :key="index" class="d-flex align-items-start mb-1">
                <span class="btn-sm d-flex align-items-center bg-light border px-3 py-1">
                  {{ author.author_name }}
                  <a v-if="author.author_link" :href="author.author_link" target="_blank"
                    class="text-white ms-1 text-decoration-underline" @click.stop>
                    🔗
                  </a>
                  <button type="button" class="btn-close btn-close-dark btn-sm ms-1" aria-label="Remove"
                    @click="removeAuthor(index)"></button>
                </span>

              </div>
            </div>
          </div>


        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-primary btn-sm rounded" @click="saveAuthors"
            :disabled="authors.length === 0" data-bs-dismiss="modal" data-bs-toggle="modal"
            data-bs-target="#feed_modal"> Save
          </button>

        </div>
      </div>
    </div>
  </div>
</teleport>

